import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "render"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import PlaylistAuditLogModal from './PlaylistAuditLogModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewAuditLogButton = _ref => {
  let {
      playlistId,
      render
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleButtonClick = () => {
    setIsModalOpen(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [render ? render(handleButtonClick) : /*#__PURE__*/_jsx(Button, Object.assign({
      onClick: handleButtonClick
    }, buttonProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.hubspotPlaylists.auditLog.viewAuditLog"
      })
    })), isModalOpen && /*#__PURE__*/_jsx(PlaylistAuditLogModal, {
      onClose: () => setIsModalOpen(false),
      playlistId: playlistId
    })]
  });
};
export default ViewAuditLogButton;